import React from 'react'
import {
  VStack,
  Text,
  Button,
  Heading,
  useColorModeValue,
} from '@chakra-ui/react'
import type { Playlist } from 'types/generated/graphql'
import { LayoutEmbedQuizPlaylist } from '../Common/LayoutEmbedQuizPlaylist'

type Props = {
  isLoading: boolean
  playlist?: Playlist
  quizzesCount: number
  onStart: () => void
}

export const EmbedStart: React.FC<Props> = ({
  isLoading,
  playlist,
  quizzesCount,
  onStart,
}) => {
  const buttonNextColor = useColorModeValue('buttonNextLight', 'buttonNextDark')

  return (
    <LayoutEmbedQuizPlaylist
      imageUrl={playlist?.imageUrl!}
      alt={playlist?.name!}
    >
      <VStack w="100%" spacing={3}>
        <Heading fontSize="xl" mb="1rem" color="white">
          {playlist?.name}
        </Heading>
        <Text fontSize="lg" mb="1rem" color="white">
          {playlist?.description}
        </Text>

        {!isLoading && quizzesCount && (
          <Heading fontSize="xl" color="white">
            全{quizzesCount}問
          </Heading>
        )}

        <Button
          isLoading={isLoading}
          backgroundColor={buttonNextColor}
          w="200px"
          mb={3}
          onClick={onStart}
        >
          スタート
        </Button>
      </VStack>
    </LayoutEmbedQuizPlaylist>
  )
}
